import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Utils from '../../utils';
import { TooltipTypes } from '../../utils/tooltipConstants';

var LevelBar = /*#__PURE__*/function (_Component) {
  _inherits(LevelBar, _Component);

  var _super = _createSuper(LevelBar);

  function LevelBar() {
    var _this;

    _classCallCheck(this, LevelBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isLevellingUp: false
    };
    return _this;
  }

  _createClass(LevelBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      var _this2 = this;

      if (this.props.xp !== nextProps.xp || this.props.gameInfo.gameId !== nextProps.gameInfo.gameId) {
        this.setState({
          showPercentage: this.props.gameInfo.gameId !== '' && this.props.xp !== nextProps.xp
        });
      }

      if (this.props.level !== nextProps.level) {
        this.setState({
          isLevellingUp: true
        });
        window.setTimeout(function () {
          _this2.setState({
            isLevellingUp: false
          });
        }, 10000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var percent = this.props.xp / this.props.xpInfo.xpRequired * 100;
      var animatedPercent = undefined; // TODO: Rip out properly -- no longer consumed by platform renderer

      var nextLevelUpBonusCoins = Utils.truncateFormat(this.props.nextLevelUpBonusCoins);
      var nextBoostMultiplier = this.props.nextBoostMultiplier;
      var nextBoostLevel = this.props.nextBoostLevel;
      var nextLevelMaxBet = Utils.truncateFormat(this.props.nextLevelMaxBet);

      var changeTooltipType = function changeTooltipType() {
        return _this3.props.changeTooltipType(_this3.props.tooltipType === TooltipTypes.XP ? null : TooltipTypes.XP);
      };

      return this.props.render({
        level: this.props.level,
        max: this.props.maxLevel,
        // percent is formatted by toFixed(0) and thus > 99.5 shows 100 - we should not show 100, 99 is max to be displayed
        // at high levels, players can be between 99.5 to 100 for many spins and display should show 99 not 100 during this time
        percent: percent <= 99 ? percent : 99,
        animatedPercent: animatedPercent,
        showPercentage: this.state.showPercentage,
        addXp: this.props.addXp,
        nextBoostMultiplier: nextBoostMultiplier,
        nextBoostLevel: nextBoostLevel,
        nextLevelUpBonusCoins: nextLevelUpBonusCoins,
        nextLevelMaxBet: nextLevelMaxBet,
        xp: this.props.xpInfo.xp,
        xpRequired: this.props.xpInfo.xpRequired,
        isLevellingUp: this.state.isLevellingUp,
        changeTooltipType: changeTooltipType,
        tooltipType: this.props.tooltipType
      });
    }
  }]);

  return LevelBar;
}(Component);

export { LevelBar as default };